import React, { Component } from "react";
import { ManageUsersBanks } from "../../ManageUsersBanks";

export class AddBanks extends Component<{}, {}> {
  render() {
    return (
      <ManageUsersBanks
        isAdminMode={false}
        history={null}
        location={null}
        match={null}
      />
    );
  }
}
